import { FC } from 'react';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import FormSelect, { FormSelectProps } from 'components/FormSelect';

interface SelectFormutilProps extends FormGroupProps<string | number> {
    name: string;
    // 限制这里只能通过Options传入select的配置项
    selectProps: Omit<FormSelectProps, 'options'> & Required<Pick<FormSelectProps, 'options'>>;
}

/**
 * @description 直接带上FormGroup封装好了选择组件
 * 项目中存在以下枚举值是Number的select, 这个组件中直接会根据选项的类型做对应处理, 不需要额外parser和formatter
 * 但需要注意, 对于枚举值是number的可选属性:
 * 1. 给出的默认值还是空字符串, 这个需要确定server对于该字段能否接受空字符串
 * 2. 默认值空字符串是表单的默认行为, 这里无法处理成默认是某个数字, 因为一般数字都有其特殊的含义
 * 3. 对于这种字段, 可以在stores/helper里面的numberFieldsToServer数组里面进行添加, 会在传给server的时候做统一处理
 *
 */
const SelectFormutil: FC<SelectFormutilProps> = props => {
    const { name, selectProps, $parser: customParser, $formatter: customFormatter, ...restProps } = props;
    const { options } = selectProps;
    const isNumberOption = options.every(option => typeof option.value === 'number');

    return (
        <FormGroup
            name={name}
            $parser={(value, $setViewValue) => {
                if (customParser) {
                    return customParser(value, $setViewValue);
                }

                return isNumberOption ? Number(value) : value;
            }}
            $formatter={(value, $setModelValue) => {
                if (customFormatter) {
                    return customFormatter(value, $setModelValue);
                }

                return value;
            }}
            {...restProps}>
            <FormSelect {...selectProps} />
        </FormGroup>
    );
};

export default SelectFormutil;
export type { OptionItem } from 'components/FormSelect';
